// inputs.js
import { validateRequired, validateLength,  validateNonZeroInteger, validateNotNull } from "../../../../helpers/validationsForm";

const Inputs = [
  {
    id: 1,
    label: "Codigo",
    name: "mar_codigo",
    type: "int",
    placeholder: "Ingrese el codigo",
    validation: (value, form) => {
      // Validación requerida
      const requiredError = validateNotNull(value);
      if (requiredError) {
        return requiredError;
      }

      // Validación de longitud
      const lengthError = validateNonZeroInteger(value);
      if (lengthError) {
        return lengthError;
      }

      // Si no hay errores
      return null;
    }
  },
  {
    id: 2,
    label: "Descripcion",
    name: "mar_descripcion",
    type: "text",
    placeholder: "Ingrese la descripcion",
    validation: (value, form) => {
      // Validación requerida
      const requiredError = validateRequired(value);
      if (requiredError) {
        return requiredError;
      }

      // Validación de longitud
      const lengthError = validateLength(value, { minLength: 2, maxLength: 40 });
      if (lengthError) {
        return lengthError;
      }

      // Si no hay errores
      return null;
    }
  },
  {
    id: 3,
    label: "Imagen",
    name: "mar_imagen",
    type: "file",
    placeholder: "Imagen",
  },
  
  {
    id: 4,
    label: "Mostrar en Web",
    name: "mar_show_web",
    type: "select",
    options: [
      { value: 0, label: 'Visible' },
      { value: 1, label: 'Oculto' },
    ],
    placeholder: "Ingrese el tipo de visualización",
  },
   {
    id: 5,
    label: "Mostrar en App",
    name: "mar_show_app",
    type: "select",
    options: [
      { value: 0, label: 'Visible' },
      { value: 1, label: 'Oculto' },
    ],
    placeholder: "Ingrese el tipo de visualización",
  },
];

export default Inputs;
